module.exports = __webpack_public_path__ + "static/media/mocha.565a2e94.svg";